import { FC, HTMLAttributes } from 'react';

import { EmptySkeletonCol, SkeletonCol, SkeletonRow, SkeletonWrapper } from './SkeletonBuilder.styles';

type SkeletonConfig = {
    /**
     * height of the skeleton line. Calculated baseHeight * height in rems
     */
    height: number;

    /**
     * width proportion of the skeleton line. How much space it should take up in the row in relation to other lines in the row
     */
    widthProportion: number;

    /**
     * If the skeleton should be empty part of line
     */
    isEmpty?: boolean;
};

type Props = HTMLAttributes<HTMLElement> & {
    /**
     * Base height of the skeleton in rems
     */
    baseHeight: number;

    /**
     * Gap between the skeleton lines, using PurPur spacing is recommended
     */
    gap: string;

    /**
     * Configuration for the skeleton
     */
    config: SkeletonConfig[][];
};

export const SkeletonBuilder: FC<Props> = ({ gap, baseHeight, config, ...props }) => {
    return (
        <SkeletonWrapper {...props} $gap={gap}>
            {config.map((row, rowIndex) => (
                <SkeletonRow key={rowIndex} $gap={gap}>
                    {row.map((skeleton, index) =>
                        skeleton.isEmpty ? (
                            <EmptySkeletonCol
                                key={`${rowIndex}${index}`}
                                $height={baseHeight * skeleton.height}
                                $flex={skeleton.widthProportion}
                            />
                        ) : (
                            <SkeletonCol
                                key={`${rowIndex}${index}`}
                                $height={baseHeight * skeleton.height}
                                $flex={skeleton.widthProportion}
                            />
                        ),
                    )}
                </SkeletonRow>
            ))}
        </SkeletonWrapper>
    );
};
